module.exports = Object.freeze({
    INFINITE_SCROLL_PAGE_SIZE: 5,
    INFINITE_SCROLL_THRESHOLD: 0.5,
    CATEGORIES_ALL: "所有文章"
});


// WEBPACK FOOTER //
// ./src/constants.js